import styled from 'styled-components';
import { Typ30 } from 'dc/Typ';
import TxtField06 from 'dc/TxtField06';
import Btn021 from 'dc/Btn021';

export const FormWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  padding-top: 8px;
  margin-bottom: 22px;
`;

export const Label = styled(Typ30)`
  margin-top: -14px; // To lessen the gap made by the error message
  margin-bottom: 4px;
  color: #546e7a;
`;

export const TextField = styled(TxtField06)``;

export const Button = styled(Btn021)``;
